/* Kaddanse — vue éclatée (section kdd-eclatee). Au survol le CSS suffit ;
   ce script gère le TAP mobile (ouvre/ferme la fiche du point) et ferme
   au tap ailleurs. Fichier assets — jamais inline (piège du morph). */
(function () {
  function fermeTout(root) {
    root.querySelectorAll('.kdd-ecl__pt--ouvert').forEach(function (p) { p.classList.remove('kdd-ecl__pt--ouvert'); });
  }

  /* Recalage horizontal (20.08) : la fiche est centrée sur son point
     (left:50% + translateX(-50%)). Un point proche d'un bord la faisait
     sortir de l'écran — 7 px de débordement en 375 px, défaut connu depuis
     le 18.08. On mesure après ouverture et on décale juste ce qu'il faut,
     sans toucher au dessin. */
  function recale(pt) {
    var fiche = pt.querySelector('.kdd-ecl__fiche');
    if (!fiche) return;
    fiche.style.transform = '';
    var marge = 12;
    var r = fiche.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var d = 0;
    if (r.right > vw - marge) d = -(r.right - (vw - marge));
    else if (r.left < marge) d = marge - r.left;
    if (d !== 0) fiche.style.transform = 'translateX(calc(-50% + ' + Math.round(d) + 'px))';
  }

  function init() {
    document.querySelectorAll('[data-kdd-eclatee]').forEach(function (root) {
      if (root.dataset.kddEclPret) return;
      root.dataset.kddEclPret = '1';
      root.querySelectorAll('.kdd-ecl__pt').forEach(function (pt) {
        pt.addEventListener('mouseenter', function () { recale(pt); });
        pt.addEventListener('click', function (e) {
          if (e.target.closest('a')) return; // laisser vivre les liens de la fiche
          var etait = pt.classList.contains('kdd-ecl__pt--ouvert');
          fermeTout(root);
          if (!etait) { pt.classList.add('kdd-ecl__pt--ouvert'); recale(pt); }
        });
      });
      /* Au repos la fiche reste dans le flux (opacity:0 ne retire pas la
         largeur) : on recale dès le chargement, sinon la page déborde de
         quelques pixels en mobile sans qu'aucune fiche soit ouverte. */
      root.querySelectorAll('.kdd-ecl__pt').forEach(recale);
      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) fermeTout(root);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('resize', function () {
    document.querySelectorAll('.kdd-ecl__pt--ouvert').forEach(recale);
  });
  document.addEventListener('shopify:section:load', init);
})();
